module.exports = __webpack_public_path__ + "img/face_shape_female_average_mask.d5fccd99.png";